import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { beginSocialPulseLogin } from "../lib/socialpulseOidc";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ssoConfig, setSsoConfig] = useState(null);

  const checkAuth = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/auth/me`, { withCredentials: true });
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    axios.get(`${API}/auth/socialpulse/config`).then((r) => setSsoConfig(r.data)).catch(() => setSsoConfig({ enabled: false }));
    // CRITICAL: If returning from OAuth callback, skip the /me check — AuthCallback handles it.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = () => {
    if (ssoConfig?.enabled) {
      beginSocialPulseLogin(ssoConfig);
      return;
    }
    // Fallback: Emergent-managed Google SSO until SocialPulse hub URL is configured.
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/community";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch {}
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, ssoConfig }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
